import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import {
  CheckboxRowWrapper,
  CheckboxInput,
  CheckboxLabel
} from './styles/StyledComponents';
import useParseHtml from '../hooks/useParseHtml';

const CheckboxRow = ({ disabled, formikProps, name, option, selectTotal }) => {
  const [checkboxDisabled, setCheckboxDisabled] = useState(false);
  const { values, setFieldValue, setValues } = formikProps;

  useEffect(() => {
    if (
      values[name]?.length === selectTotal &&
      !values[name]?.includes(option)
    ) {
      setCheckboxDisabled(true);
    } else {
      setCheckboxDisabled(false);
    }
  }, [values, name, option, selectTotal]);

  /* this function checks to see if selected user option already exists in list
   if it's not there, it is added else it's already there, it is removed */
  const manageList = () => {
    if (!values[name]?.includes(option)) {
      setFieldValue(name, [...values[name], option]);
    } else {
      let newValues = values[name].filter(val => val !== option);
      /* Previously, we were not mutating `values`, and instead calling
       * setValues API with a new object using the spread operator. That
       * worked in most cases but introduced a bug where the learner was
       * not able to clear all the checkboxes. The last checkbox would
       * not clear. When we try to clear the last checkbox the value of
       * `newValues` is an empty list. There maybe a limitation with the
       * formik library where these APIs do not work with empty lists.
       * We also tried using `setFieldValue` API.
       */
      values[name] = newValues;
      setValues(values);
    }
  };

  const parsedHtml = useParseHtml(option);

  return (
    <CheckboxRowWrapper
      disabled={disabled}
      option={option}
      value={values[name]}
    >
      <CheckboxInput
        type="checkbox"
        id={option}
        value={option}
        disabled={checkboxDisabled || disabled}
        onChange={manageList}
        checked={values[name]?.includes(option)}
      />
      <CheckboxLabel
        checkboxDisabled={checkboxDisabled}
        htmlFor={option}
        disabled={disabled}
      >
        {parsedHtml}
      </CheckboxLabel>
    </CheckboxRowWrapper>
  );
};

CheckboxRow.propTypes = {
  disabled: PropTypes.bool.isRequired,
  formikProps: PropTypes.object.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  option: PropTypes.string.isRequired,
  selectTotal: PropTypes.number.isRequired
};

export default CheckboxRow;
